export enum UIdType {
  PRODUCT = 'PRODUCT',
  RETURN = 'RETURN',
}
